// extracted by mini-css-extract-plugin
export default {"Footer":"bomPdfFooter-module_Footer_Kj6WY","FooterContent":"bomPdfFooter-module_FooterContent_TDMaL","Separator":"bomPdfFooter-module_Separator_r9cq4"};